import { Component } from "@angular/core";
import { FormBuilder, FormGroup,FormArray,  Validators } from "@angular/forms";
import { NavController, NavParams } from "ionic-angular";
import { ModalController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { HareComponent } from "../../components/harecomponent/harecomponent";
import { ListComponent } from "../../components/listcomponent/listcomponent";
import { HarelineCategory } from "../../models/interfaces/harelinecategory.model";
import { Member } from "../../models/interfaces/member.model";
import { HarelinePage } from "../../pages/hareline/hareline";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-hareline_update",
  templateUrl: "hareline_update.html",
})
export class HarelineUpdatePage {
  private dataFromOtherPage = null;
  private hare = "";
  private hares: string;
  private harelineForm: FormGroup;
  private hareM: Member[];
  private hareline;
  private hcat: HarelineCategory;
  private hl_comment: string;
  private hl_jm_comment: string;
  private hl_datetime: string;
  private hl_gps: string;
  private hl_guestfee: string;
  private hl_hare: string;
  private hl_hare$: any;
  private hl_id: number;
  private hc_id: number;
  private hl_scribe: string;
  private hl_runfee: string;
  private hl_runno: string;
  private hl_runsite: string;
  private hl_runtype: string;
  private hl_scribe$: any;
  private scribe = "";
  private id: string;
  private MaxYear = new Date(new Date());
  private MM = parseInt(this.MaxYear.toISOString().substring(0, 4)) + 2;
  private scribeM: Member[];
  private styleName: string ="";

  constructor(private configService: ConfigService,public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, private db: DbserviceProvider, public modalCtrl: ModalController,
  ) {
    console.log("HarelineUpdatePage constructor :this.navParams " && this.navParams);
    this.styleName=this.configService.getConfig("STYLENAME");
    this.hl_id = this.navParams.get("hareline").hl_id;
    this.hc_id = this.navParams.get("hareline").hc_id;
    this.harelineForm = this.formBuilder.group({
      "hc_id": ["[this.hc_id"],
      "hl_datetime": [""],
      "hl_id": [this.hl_id],
      "hl_runno": ["", [Validators.required, Validators.min(0), Validators.max(9999)]],
      "hl_hare": [""],
      "hl_scribe": [""],
      "hl_runsite": [""],
      "hl_gps": [""],
      "hl_comment": [""],
      "hl_jm_comment": [""],
      "hl_guestfee": [""],
      "guestfees": this.formBuilder.array([]),
    });

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Guest'"
    })
      .subscribe((defguestfee) => {
        //this.guestfees = defguestfee
        this.navParams.get("guestfee").forEach(gf => {
          this.addGuestFee(gf);
        });
        this.harelineForm.controls.hl_guestfee.setValue(defguestfee[0].se_key_value);
      });

  }

  addGuestFee(guestfee: any) {
    console.log("HarelineAddPage addGuestFee");
    this.guestfees.push(this.createGuestFeeGroup(guestfee));
  }

  get guestfees(): FormArray {
    console.log("HarelineAddPage addGuestFee");
    return <FormArray>this.harelineForm.get('guestfees');
  }

  createGuestFeeGroup(guestfee: any): FormGroup {
    console.log("HarelineAddPage createGuestFeeGroup");
    return this.formBuilder.group({
      gf_id: [guestfee.gf_id, ],
      name: [guestfee.gf_name, [Validators.required]],
      amount: [guestfee.gf_amount, [Validators.required]]
    })
  }

  private callback = (data) => {
    this.dataFromOtherPage = data;
    console.log("data received from other page", this.dataFromOtherPage);
  }

  private ionViewWillEnter() {
    console.log("HarelineUpdatePage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("HarelineUpdatePage onInitPage");

    this.db.dbCol({
      "action": "select", "mapObject": "hareline_category",
      "sqlExtended": " order by hareline_category.hc_order"
    }).subscribe((data) => {
      this.hcat = data;
    });

    this.hareline = this.navParams.get("hareline");
    this.harelineForm.controls.hl_id.setValue(this.hl_id);
    this.harelineForm.controls.hc_id.setValue(this.hc_id);
    this.harelineForm.controls.hl_runno.setValue(this.hareline.hl_runno);
    this.harelineForm.controls.hl_datetime.setValue(this.hareline.hl_datetime);
    this.harelineForm.controls.hl_hare.setValue(this.hareline.hl_hare);
    this.harelineForm.controls.hl_scribe.setValue(this.hareline.hl_scribe);
    this.harelineForm.controls.hl_runsite.setValue(this.hareline.hl_runsite);
    this.harelineForm.controls.hl_gps.setValue(this.hareline.hl_gps);

    this.harelineForm.controls.hl_comment.setValue(this.hareline.hl_comment);
    this.harelineForm.controls.hl_jm_comment.setValue(this.hareline.hl_jm_comment);
    this.harelineForm.controls.hl_guestfee.setValue(this.hareline.hl_guestfee);

    this.hl_scribe$ = this.db.dbCol({
      "action": "select", "mapObject": "vw_hareline",
      "sqlExtended": " where hl_id = '" +
        this.hl_id + "' and hs_type='S'"})
        .subscribe((scribe) => {
      this.scribeM = scribe;
      for (let j = 0; j < (scribe as any).length; j++) {
        this.scribe = this.scribe + scribe[j].mb_hashname + ",";
      }
      this.scribe = this.scribe.slice(0, -1);
    },
    );

    this.hl_hare$ = this.db.dbCol({
      "action": "select", "mapObject": "vw_hareline",
      "sqlExtended": " where hl_id = '" +
        this.hl_id + "' and hs_type='H'"})
        .subscribe((hare) => {
      this.hareM = hare;
      for (let j = 0; j < (hare as any).length; j++) {
        this.hare = this.hare + hare[j].mb_hashname + ",";
      }
      this.hare = this.hare.slice(0, -1);
    },
    );
  }

  private openOtherPage() {
    this.navCtrl.push("OtherPage", {
      "callback": this.callback,
    });
  }

  private selectScribeList(val) {
    console.log("HarelineAddPage selectScribeList");
    let selection = this.modalCtrl.create(ListComponent, { "obs": "member", "sel": val, "type": "S" });

    selection.present();
    selection.onDidDismiss((data) => {
      if (data !== null) {
        this.scribeM = data;
        this.scribe = data.map((v) => v.mb_hashname).toString();
      }
    });
  }

  private selectHareList(val) {
    console.log("HarelineAddPage HareComponent");
    let selection = this.modalCtrl.create(HareComponent, { "obs": "member", "sel": val });
    selection.present();
    selection.onDidDismiss((data) => {
      if (data !== null) {
        this.hareM = data;
        this.hare = data.map((v) => v.mb_hashname).toString();
      }
    });
  }

  private ngOnDestroy() {
    console.log("HarelineUpdatePage ngOnDestroy");
  }

  private goback() {
    console.log("HarelineUpdatePage goback");
    this.navCtrl.pop();
  }

  private updateHareline(id: string, value: any) {
    console.error("HarelineUpdatePage updateHareline");
   /*Check if gps is null or empy*/
    if(typeof this.harelineForm.controls.hl_gps.value!='undefined' && this.harelineForm.controls.hl_gps.value){
      this.harelineForm.controls.hl_gps.setValue(this.harelineForm.controls.hl_gps.value.replace(/[\])}[{(]/g, '')  );  
   }
  
    this.db.dbCol({ "action": "update", "mapObject": "hareline", 
    "hc_id": this.harelineForm.controls.hc_id.value , 
    "hl_datetime": this.harelineForm.controls.hl_datetime.value , 
    "hl_id": this.harelineForm.controls.hl_id.value , 
    "hl_runno": this.harelineForm.controls.hl_runno.value , 
    "hl_runsite": this.harelineForm.controls.hl_runsite.value,
    "hl_gps": this.harelineForm.controls.hl_gps.value,
    "hl_comment": this.harelineForm.controls.hl_comment.value,
    "hl_jm_comment": this.harelineForm.controls.hl_jm_comment.value })
      .subscribe((ret) => {
        this.db.dbCol({
          "action": "dml", "mapObject": "dml", "query": "DELETE FROM hareline_assistant WHERE hl_id='"
            + this.hl_id + "'",
        })
          .subscribe(
            (ret1) => {
              if (this.hareM && this.hareM.length) {
                this.hareM.forEach((el) => {
                  this.db.dbCol({ "action": "insert", "mapObject": "hareline_assistant", "mb_id": (el as any).mb_id, "hl_id": this.hl_id, "hs_type": "H" })
                    .subscribe();
                });
              }
              if (this.scribeM && this.scribeM.length) {
                this.scribeM.forEach((el) => {
                  this.db.dbCol({ "action": "insert", "mapObject": "hareline_assistant", "mb_id": (el as any).mb_id, "hl_id": this.hl_id, "hs_type": "S" })
                    .subscribe();
                });
              }

              if (this.guestfees.value !== undefined) {
                this.guestfees.value.forEach((el) => {
                  this.db.dbCol({ "action": "update", "mapObject": "guest_fee", "gf_id": el.gf_id, "hl_id": ret.id, "gf_name": el.name, "gf_amount": el.amount })
                    .subscribe();
                });
              }


              this.navCtrl.pop();
            },
          );
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/hareline/hareline_update.ts